import {
  ApiClientError,
  GetCatalogsQuery,
  Paginated,
  CatalogLocation,
} from '@raydiant/api-client-js';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';

export default function useCatalogLocations(
  catalogId: string,
  opts: GetCatalogsQuery,
) {
  return useProtectedQuery<Paginated<CatalogLocation>, ApiClientError>(
    keys.catalogLocations(catalogId, opts),
    () => raydiant.getCatalogLocations(catalogId, opts),
  );
}
